import { WithPermissions } from '@Components/common/with-permissions'
import { Routes } from '@Components/main-app/types'
import { useSortable } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'
import { AuthScopes } from '@Generated/back-office-client/src'
import { DragHandleDots2Icon } from '@radix-ui/react-icons'
import { Flex, Text } from '@radix-ui/themes'
import { Link } from 'react-router-dom'
import { EditableGame } from '../types'

/**
 * A game in the playslip picker's order. The drag attributes and listeners sit on the handle alone,
 * so clicking the row still opens the game and the keyboard sensor has something focusable to drag from.
 */
export const SortableGameRow = ({ game }: { game: EditableGame }) => {
  const { attributes, listeners, setNodeRef, setActivatorNodeRef, transform, transition } =
    useSortable({ id: game.id })

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  }

  return (
    <Flex
      ref={setNodeRef}
      style={style}
      className="game-row"
      data-testid={`game-row-${game.id}`}
      align="center"
      gap="3">
      <WithPermissions requiredPermissions={AuthScopes.writegames}>
        <Flex
          ref={setActivatorNodeRef}
          className="game-row-drag-handle"
          aria-label={`Reorder ${game.name}`}
          {...attributes}
          {...listeners}>
          <DragHandleDots2Icon />
        </Flex>
      </WithPermissions>

      <Link className="game-row-link" to={Routes.GAME_DETAIL.replace(':gameId', game.id)}>
        <Flex direction="column" align="start" gap="1">
          <Text size="3" weight="medium">
            {game.name}
          </Text>
          <Text size="1" color="gray">
            {game.gameId ?? game.id}
          </Text>
        </Flex>
      </Link>
    </Flex>
  )
}
